import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Dialog from 'rc-dialog';
import 'rc-dialog/assets/index.css';

class Modal extends React.PureComponent {
    state = {
        isOpen: this.props.isOpen || false,
    };

    static propTypes = {
        isOpen: PropTypes.bool.isRequired,
        title: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
        children: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
        className: PropTypes.string,
        maskClosable: PropTypes.bool,
        onCancel: PropTypes.func,
        onOk: PropTypes.func,
        okText: PropTypes.string,
        cancelText: PropTypes.string,
        footer: PropTypes.bool,
        maskStyle: PropTypes.object,
        onClose: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
        footerStyle: PropTypes.object,
        isGysdVote: PropTypes.bool,
    };

    static defaultProps = {
        isOpen: false,
        className: '',
        maskClosable: false,
        onCancel: () => {},
        onOk: () => {},
        onClose: () => {},
        footer: true,
        isGysdVote: true,
    };

    ref = React.createRef();

    static getDerivedStateFromProps(nextProps, state) {
        let resIsOpen = {};

        if (nextProps.isOpen !== state.isOpen) {
            resIsOpen = {
                isOpen: nextProps.isOpen,
            };
        }

        return { ...resIsOpen };
    }

    // 关闭弹窗
    close() {
        this.setState(
            {
                isOpen: false,
            },
            () => {
                this.ref.current.style.marginTop = 0;
            },
        );
    }

    emptyFunc() {}
    // 点击确定触发的事件
    handleOk = () => {
        this.props.onOk();
        // this.close();
    };
    // 点击取消触发的事件
    handleCancel = () => {
        const { onCancel } = this.props;

        onCancel();
        this.close();
        this.props.onClose();
    };
    // 点击关闭触发的事件
    handleClose = () => {
        const { onClose } = this.props;

        // 可自定义关闭按钮是否可用
        if (Object.prototype.toString.call(onClose) === '[object Object]') {
            if (onClose.closeAble !== false) {
                onClose.callback();
                this.close();
            } else {
                onClose.callback();
            }
        } else if (Object.prototype.toString.call(onClose) === '[object Function]') {
            onClose();
            this.close();
        }
    };
    dialogHandleClose() {
        const { onClose } = this.props;

        onClose();
        this.close();
    }

    componentWillUnmount() {
        this.setState = (state, callback) => {
            return;
        };
    }

    render() {
        const {
            title,
            children,
            className,
            okText,
            cancelText,
            maskClosable,
            footer,
            footerStyle,
            maskStyle,
            isGysdVote,
        } = this.props;

        const { isOpen } = this.state;

        return (
            <Dialog forceRender visible={isOpen} onClose={close} wrapClassName={styles.wrap} maskClosable>
                <div style={{ display: isOpen ? 'block' : 'none' }}>
                    <div
                        className={`${styles.modal_mask} ${className}`}
                        style={{ ...maskStyle }}
                        onClick={maskClosable ? this.handleCancel : this.emptyFunc}>
                        <div
                            ref={this.ref}
                            className={styles.modal_body}
                            onClick={e => {
                                e.stopPropagation();
                            }}>
                            <img
                                className={styles.modal_img}
                                src="https://x0.ifengimg.com/ucms/2021_40/3FB5EFF2E911574F24F8D8C2342A613DD592226A_size91_w960_h420.png"
                            />
                            {title ? (
                                <div className={styles.modal_title}>
                                    <div style={{ float: 'left' }}>{title}</div>
                                    <div className={styles.close} onClick={this.handleClose} />
                                </div>
                            ) : null}
                            <div className={styles.modal_contianer} ref="contianer">
                                {isOpen ? children : null}
                            </div>
                            {footer ? (
                                <div
                                    className={
                                        !isGysdVote ? `${styles.modal_footer}` : `${styles.gysdVotemodal_footer}`
                                    }
                                    style={footerStyle}>
                                    {!isGysdVote ? (
                                        <div className={` ${styles.clearfix}`}>
                                            <span className={styles.cancel_btn} onClick={this.handleCancel}>
                                                {cancelText || '取消'}
                                            </span>
                                            <span className={styles.confirm_btn} onClick={this.handleOk}>
                                                {okText || '确认'}
                                            </span>
                                        </div>
                                    ) : (
                                        <div className={` ${styles.clearfix}`}>
                                            <span className={styles.gysdVoteCancel_btn} onClick={this.handleCancel}>
                                                <img
                                                    src="//x0.ifengimg.com/ucms/2021_40/F26DAF54205959B3723A503261306374207D2747_size1_w90_h90.png"
                                                    alt=""
                                                />
                                            </span>
                                        </div>
                                    )}
                                </div>
                            ) : null}
                        </div>
                    </div>
                </div>
            </Dialog>
        );
    }
}

export default errorBoundary(Modal);
